import React, { useState } from 'react';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';
import AIFeedbackRow from './AIFeedbackRow';

const AIFeedbackGroup = ({ unitName, feedbacks, setFeedbacks, handleDelete }) => {
  const [currentPlayingId, setCurrentPlayingId] = useState(null); // Track which audio is playing

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Unit name: {unitName}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Level</TableCell>
              <TableCell>User</TableCell> 
              <TableCell>Date</TableCell> 
              <TableCell sx={{ width: '25%' }}>Phrase</TableCell> 
              <TableCell>Play/Pause</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>AI Score</TableCell>
              <TableCell sx={{ width: '30%' }}>AI Output</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feedbacks
              .sort((a, b) => a.order - b.order) // Sort by order
              .map((feedback) => (
                <AIFeedbackRow
                  key={feedback._id}
                  feedback={feedback}
                  currentPlayingId={currentPlayingId}
                  setCurrentPlayingId={setCurrentPlayingId}
                  setFeedbacks={setFeedbacks}
                  handleDelete={handleDelete}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AIFeedbackGroup;
